/**
 * Shared Swiper breakpoints for all carousel presets.
 * Px values align with _src/_data/designTokens/breakpoints.json:
 * - BP_SM → m (640)
 * - BP_MD → l (920)
 */

export const BP_SM = 640;
export const BP_MD = 920;

/** Default: one full slide + ~20% of the next */
export const MOBILE_SLIDES_PER_VIEW = 1.2;
/** Tablet: one full slide + half of the next */
export const TABLET_SLIDES_PER_VIEW = 1.5;
/** Desktop peek-grid: outer slides partially clipped */
export const PEEK_GRID_SLIDES_PER_VIEW = 3.4;

/**
 * Standard slidesPerView ladder (mobile → tablet → desktop).
 * @param {number} desktopPerView
 * @returns {Record<number, { slidesPerView: number }>}
 */
export function slidesPerViewBreakpoints(desktopPerView) {
    return {
        [BP_SM]: {slidesPerView: TABLET_SLIDES_PER_VIEW},
        [BP_MD]: {slidesPerView: desktopPerView},
    };
}
